import { render, staticRenderFns } from "./BankListMobile.vue?vue&type=template&id=7a0b2163&scoped=true&"
import script from "./BankListMobile.vue?vue&type=script&lang=js&"
export * from "./BankListMobile.vue?vue&type=script&lang=js&"
import style0 from "./BankListMobile.vue?vue&type=style&index=0&id=7a0b2163&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0b2163",
  null
  
)

export default component.exports